export enum LaborOrderState {    
    Saved,
    Ordered,
    Rejected,
    Filled
}

export const LaborOrderStateDisplay = ["Saved", "Ordered", "Rejected", "Filled"];